import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common'
import { Events } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';

import * as L from "leaflet";
import * as esri from 'esri-leaflet';
import 'leaflet-timedimension';


@Component({
    selector: 'page-home',
    templateUrl: 'home.html'
})


export class HomePage {

    @ViewChild('map') mapContainer: ElementRef;
    @ViewChild('colorbar', { read: ElementRef }) colorbar: ElementRef;

    env_fields_array: any = []

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    constructor(
        public navCtrl: NavController,
        public common: CommonProvider,
        // private storage: Storage,
        private events: Events,
        private sanitizer: DomSanitizer
    ) {

        events.subscribe('map:setlayer', (layer: string, mapfile: string) => {
            this.setLayer(layer, mapfile);
        });

        events.subscribe('map:setSimulationLayers', (simulation: any, zoom: boolean, curr_oil0: any) => {
            console.log("SUBSCRIBE map:setSimulationLayers", simulation, curr_oil0);
            this.common.setMarker({ 'lat': simulation.payload.start_lat, 'lng': simulation.payload.start_lon })
            this.setSimulationLayers(simulation, this.common.map, zoom, curr_oil0);
        });

        L.TimeDimension.Layer.WMS.CMCC = L.TimeDimension.Layer.WMS.extend({

            _createLayerForTime: function (time: any) {
                let date = new Date(time);
                let year = date.getFullYear();
                let month = ("0" + (date.getUTCMonth() + 1)).slice(-2);
                let day = ("0" + date.getUTCDate()).slice(-2);
                let hours = ("0" + new Date(time).getUTCHours()).slice(-2);
                let timestep = year + month + day + '_' + hours
                let layers = [];
                let url = this._baseLayer.getURL();

                if (this._baseLayer.options.visualization_options.curr_sim_res_env === 'temperature') {
                    // SST
                    layers.push("sst_" + timestep);
                } else if (this._baseLayer.options.visualization_options.curr_sim_res_env === 'waveheight') {
                    // WAVE PERIOD
                    layers.push("vhm0_" + timestep);
                    // layers.push("vdir_" + timestep);
                } else if (this._baseLayer.options.visualization_options.curr_sim_res_env === 'waveperiod') {
                    // WAVE HEIGHT
                    layers.push("vtza_" + timestep);
                    // layers.push("vdir_" + timestep);
                } else if (this._baseLayer.options.visualization_options.curr_sim_res_env === 'currents') {
                    // CURRENTS
                    layers.push("curr_" + timestep);
                    // layers.push("curr-direction_" + timestep);
                } else if (this._baseLayer.options.visualization_options.curr_sim_res_env === 'wind') {
                    // WIND
                    layers.push("wind_" + timestep);
                    // layers.push("wind-direction_" + timestep);
                }

                // TOTAL OIL
                if (this._baseLayer.options.visualization_options.curr_sim_res_totaloil) {
                    layers.push("mdslk_totaloil_" + timestep);
                }
                // BEACHED
                if (this._baseLayer.options.visualization_options.curr_sim_res_beached) {
                    layers.push("mdslk_beached_" + timestep);
                }

                // DIRECTIONS
                if (this._baseLayer.options.visualization_options.curr_sim_res_env === 'temperature') {
                    // SST
                    // layers.push("sst_" + timestep);
                } else if (this._baseLayer.options.visualization_options.curr_sim_res_env === 'waveheight') {
                    // WAVE PERIOD
                    // layers.push("vhm0_" + timestep);
                    layers.push("vdir_" + timestep);
                } else if (this._baseLayer.options.visualization_options.curr_sim_res_env === 'waveperiod') {
                    // WAVE HEIGHT
                    // layers.push("vtza_" + timestep);
                    layers.push("vdir_" + timestep);
                } else if (this._baseLayer.options.visualization_options.curr_sim_res_env === 'currents') {
                    // CURRENTS
                    // layers.push("curr_" + timestep);
                    layers.push("curr-direction_" + timestep);
                } else if (this._baseLayer.options.visualization_options.curr_sim_res_env === 'wind') {
                    // WIND
                    // layers.push("wind_" + timestep);
                    layers.push("wind-direction_" + timestep);
                }
                this._baseLayer.options.layers = layers.join();
                return new this._baseLayer.constructor(url, this._baseLayer.options);
            },

            _requestTimeDimensionFromCapabilities: function () {
                if (this._capabilitiesRequested) {
                    return;
                }
                this._capabilitiesRequested = true;
                let url = this._getCapabilitiesUrl();
                if (this._proxy) {
                    url = this._proxy + '&url=' + encodeURIComponent(url);
                }
                let oReq = new XMLHttpRequest();
                oReq.addEventListener("load", (function (xhr) {
                    var data = xhr.currentTarget.responseXML;
                    if (data !== null) {
                        //  ****************** DEFAULT TIME ******************
                        this._defaultTime = Date.parse(this._getDefaultTimeFromCapabilities(data));
                        this._setDefaultTime = this._setDefaultTime || (this._timeDimension && this._timeDimension.getAvailableTimes().length == 0);
                        this.setAvailableTimes(this._parseTimeDimensionFromCapabilities(data));
                        if (this._setDefaultTime && this._timeDimension) {
                            this._timeDimension.setCurrentTime(this._defaultTime);
                        }
                    }
                }).bind(this));
                oReq.overrideMimeType('application/xml');
                oReq.open("GET", url);
                oReq.send();
            },

            _parseTimeDimensionFromCapabilities: function(xml) {
                var layers = xml.querySelectorAll('Layer[queryable="1"]');
                var layerName = 'IDXLAYER'
                var layer = null;
                var times = null;
                layers.forEach(function(current) {
                    if (current.querySelector("Name").innerHTML === layerName) {
                        layer = current;
                    }
                })
                if (layer) {
                    times = this._getTimesFromLayerCapabilities(layer);
                    if (!times) {
                        times = this._getTimesFromLayerCapabilities(layer.parentNode);
                    }
                }
                return times;
            },

            _getTimesFromLayerCapabilities: function(layer) {
                var times = null;
                var nodes = layer.children;
                for (var i=0, l=nodes.length; i<l; i++){
                    if (nodes[i].nodeName !== 'Extent' && nodes[i].nodeName !== 'Dimension') continue;
                    if (nodes[i].getAttribute('name') !== 'time') continue;
                    if (!nodes[i].textContent.length) continue;
                    times = nodes[i].textContent.trim();
                    break;
                }
                return times;
            },

            _getbbox: function (callback, map, zoom) {
                let url = this._getCapabilitiesUrl();
                if (this._proxy) {
                    url = this._proxy + '&url=' + encodeURIComponent(url);
                }
                var oReq = new XMLHttpRequest();
                oReq.addEventListener("load", (function (xhr) {
                    var data = xhr.currentTarget.responseXML;
                    if (data !== null) {
                        //  ****************** EXTENT ******************                        
                        var layers = data.querySelectorAll('Layer[queryable="1"]');
                        var layerName = "WMS_server_CMCC";  //this._baseLayer.wmsParams.layers;
                        var layer = null;
                        layers.forEach(function (current) {
                            if (current.querySelector("Name").innerHTML === layerName) {
                                layer = current;
                            }
                        })
                        if (layer) {
                            let bbox = layer.querySelector('BoundingBox');
                            let minx = bbox.getAttribute("minx")
                            let miny = bbox.getAttribute("miny")
                            let maxx = bbox.getAttribute("maxx")
                            let maxy = bbox.getAttribute("maxy")
                            let bounds = [[miny, minx], [maxy, maxx]];  //L.latLngBounds(southWest, northEast);
                            callback(bounds, map, zoom)
                        }
                    }
                }).bind(this));
                oReq.overrideMimeType('application/xml');
                oReq.open("GET", url);
                oReq.send();
            },

        });

        L.timeDimension.layer.wms.CMCC = function (layer, options) {
            let ret = new L.TimeDimension.Layer.WMS.CMCC(layer, options);
            return ret;
        };

        this.common.simulationLayer = null;
        this.common.simulationTimeLayer = null;
        this.common.timeDimensionControl = null;
        this.common.colorbarEnvUrl = null
        this.common.colorbarOilUrl = null
    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    ionViewDidEnter() {
        setTimeout(() => {
            this.loadmap();
        }, 150);
    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    loadmap() {
        let satellite = esri.basemapLayer('ImageryClarity')
        let hybrid = esri.basemapLayer('Topographic')

        this.common.map = L.map("map", {
            maxBounds: L.latLngBounds([-90, -180], [90, 180]),
            center: [40, 18],
            zoom: 5,
            minZoom: 2,
        });

        let baseLayers = {
            "Satellite": satellite,
            "Hybrid": hybrid,
        }

        // default base map
        this.common.map.addLayer(hybrid)

        let graticule = L.latlngGraticule({
            showLabel: true,
            zoomInterval: [
                { start: 1, end: 3, interval: 30 },
                { start: 4, end: 4, interval: 10 },
                { start: 5, end: 7, interval: 5 },
                { start: 8, end: 28, interval: 1 }
            ]
        })
        this.common.map.addLayer(graticule)

        let controlLayers = L.control.layers(baseLayers, null,
            {
                position: 'bottomright',
                collapsed: false
            }
        )
        controlLayers.addTo(this.common.map);

        this.common.map.fitWorld();

        this.common.map.on('baselayerchange', function (el: { layer: { bringToBack: () => void; }; }) {
            el.layer.bringToBack()
        });

        this.common.map.on('click', (e: { latlng: any; }) => {
            this.events.publish('map:clicked', e.latlng);
            this.common.setMarker(e.latlng);
        });

        this.common.map.on('overlayadd', function (eventLayer) {
            // console.log('overlayadd', eventLayer);
        });

    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    submitBtn() {

        this.common.curr_simulation = null;

        if (this.isValidPayload(this.common.payload)==false) return;

        if (this.common.simulationLayer) this.common.map.removeLayer(this.common.simulationLayer);
        if (this.common.simulationTimeLayer) this.common.map.removeLayer(this.common.simulationTimeLayer);
        if (this.common.timeDimensionControl) this.common.map.removeControl(this.common.timeDimensionControl);
        if (this.common.map.timeDimension) this.common.map.timeDimension = null;
        this.common.colorbarOilUrl = null
        this.common.colorbarEnvUrl = null

        this.common.sendPostRequest(this.common.payload).then((response: any) => {

            console.log("SSA response: ", response)

            if (response.exception) {
                this.common.showAlert(
                    'ERROR',
                    'SSA, CDAM or Medslik error',
                    'Exception: ' + response.exception
                )
            } else {
                this.common.showAlert(
                    'JOB SUBMITTED',
                    'Waiting for results...',
                    'Simulation ' + response.id + ' submitted. <br>You will be notified once completed.'
                );
            }
        }).catch((err) => {
            console.log("CATCH Response: ", JSON.stringify(err));
            this.common.showAlert(
                'ERROR',
                'SSA, CDAM or Medslik error',
                'Exception: ' + JSON.stringify(err)
            );
        })
    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    isValidPayload(payload) {
        let valid: boolean = true;
        console.log("isValidPayload: ", payload);

        valid=this.common.is_ocean
        if (!valid) {
            this.common.showAlert("ERROR!", "Wrong coordinates", "Please, select a point at sea!")
            return false
        }

        // start_lat
        let lat = parseFloat(payload.start_lat)
        valid = payload.start_lat.trim() != '' && isFinite(lat) && Math.abs(lat) <= 90;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid latitute " + payload.start_lat, "Please, insert a valid latitude value!");
            return false
        }
        // start_lon
        let lon = parseFloat(payload.start_lon)
        valid = payload.start_lon.trim() != '' && isFinite(lon) && Math.abs(lon) <= 180;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid longitude " + payload.start_lon, "Please, insert a valid longitude value!");
            return false
        }
        // sim_length
        let sim_length = parseFloat(payload.sim_length)
        valid = payload.sim_length.trim() != '' && isFinite(sim_length) && sim_length > 0 && sim_length <= 168;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid simulation length " + payload.sim_length, "Simulation length [hours] is not correct. Allowable range is [1 .. 168].");
            return false
        }
        // day
        let day = parseInt(payload.day)
        valid = isFinite(day) && day >= 1 && day <= 31;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid day " + payload.day, "Please, insert a valid day value!");
            return false
        }
        // month
        let month = parseInt(payload.month)
        valid = isFinite(month) && month >= 1 && month <= 12;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid month " + payload.month, "Please, insert a valid month value!");
            return false
        }
        // year
        let year = parseInt(payload.year)
        valid = isFinite(year) && year >= 20 && year <= 30;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid year " + payload.year, "Please, insert a valid year value!");
            return false
        }
        // hour
        let hour = parseInt(payload.hour)
        valid = isFinite(hour) && hour >= 0 && hour <= 23;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid hour " + payload.hour, "Please, insert a valid hour value!");
            return false
        }
        // minutes
        let minutes = parseInt(payload.minutes)
        valid = isFinite(minutes) && minutes >= 0 && minutes <= 59;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid minutes " + payload.minutes, "Please, insert a valid minutes value!");
            return false
        }
        // lat_degree
        let lat_degree = parseFloat(payload.lat_degree)
        valid = isFinite(lat_degree) && Math.abs(lat_degree) <= 90;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid lat_degree " + payload.lat_degree, "Please, insert a valid lat_degree value!");
            return false
        }
        //lat_minutes
        let lat_minutes = parseFloat(payload.lat_minutes)
        valid = isFinite(lat_minutes) && lat_minutes >= 0 && lat_minutes <= 99;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid lat_minutes " + payload.lat_minutes, "Please, insert a valid lat_minutes value!");
            return false
        }
        // lon_degree
        let lon_degree = parseFloat(payload.lon_degree)
        valid = isFinite(lon_degree) && Math.abs(lon_degree) <= 180;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid lon_degree " + payload.lon_degree, "Please, insert a valid lon_degree value!");
            return false
        }
        // lon_minutes
        let lon_minutes = parseFloat(payload.lon_minutes)
        valid = isFinite(lon_minutes) && lon_minutes >= 0 && lon_minutes <= 99;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid lon_minutes " + payload.lon_minutes, "Please, insert a valid lon_minutes value!");
            return false
        }
        // spillType
        let spillType = parseInt(payload.spillType)
        valid = spillType == 1 || spillType == 2;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid spillType " + payload.spillType, "Spill type is not correct. Allowable range is [1,2].");
            return false
        }

        // duration
        // NB: da correggere, valutare solo in caso di spillType==2
        let duration = parseInt(payload.duration)
        valid = isFinite(duration) && duration > 0 && duration <= 168;
        if (!valid && parseInt(payload.spillType) == 2) {
            this.common.showAlert("Error!", "Invalid duration " + payload.duration, "Duration [hours] is not correct. Allowable range is [0 ... 168].");
            return false
        }
        // spillrate
        // NB: in caso di spillType==1 (Instantaneous) curr_totvolume==spillrate
        let spillrate = parseInt(payload.spillrate)
        valid = isFinite(spillrate) && spillrate > 0 && spillrate <= 1000000;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid spillrate " + payload.spillrate, "Spill rate [tons/hours] is not correct. Allowable range is [0 ... 1000000].");
            return false
        }

        // oil

        // oiltype

        // var_02 - Stokes drift
        let var_02 = parseFloat(payload.var_02)
        valid = isFinite(var_02) && (var_02 == 0 || var_02 == 1);
        if (!valid) {
            this.common.showAlert("Error!", "Invalid Stokes drift " + payload.var_02, "Stokes drift is not correct. Allowable range is [0, 1].");
            return false
        }

        // var_03 - Wind correction
        let var_03 = parseFloat(payload.var_03)
        valid = isFinite(var_03) && var_03 >= 0 && var_03 <= 3;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid Wind correction " + payload.var_03, "Wind correction is not correct. Allowable range is [0 ... 3].");
            return false
        }

        // var_10 - Horizontal diffusivity
        let var_10 = parseFloat(payload.var_10)
        valid = isFinite(var_10) && var_10 >= 0 && var_10 <= 20;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid Horizontal diffusivity " + payload.var_10, "Horizontal diffusivity is not correct. Allowable range is [0 ... 20].");
            return false
        }

        // var_14 - Oil parcel number is not correct. Allowable range is [10000 ... 300000].
        let var_14 = parseFloat(payload.var_14)
        valid = isFinite(var_14) && var_14 >= 10000 && var_14 <= 300000;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid Oil parcel number " + payload.var_14, "Oil parcel number is not correct. Allowable range is [10000 ... 300000].");
            return false
        }

        // var_19 - Evaporation rate is not correct. Allowable range is [0.00001 ... 0.01].
        let var_19 = parseFloat(payload.var_19)
        valid = isFinite(var_19) && var_19 >= 0.00001 && var_19 <= 0.01;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid Evaporation rate " + payload.var_19, "Evaporation rate is not correct. Allowable range is [0.00001 ... 0.01].");
            return false
        }

        // var_29 - Dispersion rate is not correct. Allowable range is [0.000001 ... 0.001].
        let var_29 = parseFloat(payload.var_29)
        valid = var_29 >= 0.000001 && var_29 <= 0.01;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid Dispersion rate " + payload.var_29, "Dispersion rate is not correct. Allowable range is [0.000001 ... 0.001].");
            return false
        }

        // var_39 - Thick slick spreading rate is not correct. Allowable range is [10 ... 200].
        let var_39 = parseFloat(payload.var_39)
        valid = isFinite(var_39) && var_39 >= 10 && var_39 <= 200;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid Thick slick spreading rate " + payload.var_39, "Thick slick spreading rate is not correct. Allowable range is [10 ... 200].");
            return false
        }

        // plotStep
        let plotStep = parseInt(payload.plotStep)
        valid = isFinite(plotStep) && plotStep >= 1 && plotStep <= 24;
        if (!valid) {
            this.common.showAlert("Error!", "Invalid Output frequency [hours] " + payload.plotStep, "Output frequency [hours] is not correct. Allowable range is [1 ... 24].");
            return false
        }

        // "selector": "", ["witoil","uncertainty"]
        // "uncert_type": "", [position/...]
        // "hex": "", [0,1]

        // uncert_radius - Uncertainty distance is not correct. Allowable range is [0.1 ... 9.9].
        let selector = payload.selector
        if (selector == 'uncertainty') {
            let uncert_radius = parseInt(payload.uncert_radius)
            valid = uncert_radius >= 0.1 && uncert_radius <= 9.9;
            if (!valid) {
                this.common.showAlert("Error!", "Invalid Uncertainty distance " + payload.uncert_radius, "Uncertainty distance is not correct. Allowable range is [0.1 ... 9.9].");
                return false
            }
        }

        // "Output frequency" can't be greater than "simulation length
        if (plotStep > sim_length) {
            this.common.showAlert("Error!", "Invalid Output frequency and simulation length ", "\"Output frequency\" can't be greater than \"simulation length\"!");
            return false
        }

        return true;
    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    setLayer(layers: string, mapfiles: string) {

        console.log('setlayer: ', layers, mapfiles);

        if (this.common.map) {
            this.common.map.eachLayer((layer: { _url: string; }) => {
                if (layer._url == this.common.env_fileds_url) {
                    console.log("LAYER to be removed: ", layer._url, layer)
                    if (layer) this.common.map.removeLayer(layer);
                }
            });
        }

        if (layers && mapfiles) {
            let url = this.common.env_fileds_url;
            let layers2show = layers.split(",").filter(function (el) { return el.length != 0 })
            let maps = mapfiles.split(",").filter(function (el) { return el.length != 0 })


            for (let i = 0; i < layers2show.length; i++) {

                let mapfile = maps[i]

                let wmsLayer = L.tileLayer.wms(url, {
                    layers: layers2show[i],
                    version: '1.3.0',
                    tms: false,
                    format: 'image/png',
                    transparent: true,
                    errorTileUrl: 'assets/imgs/error.png',
                    attribution: '<a href="http://www.cmcc.it">CMCC</a>',
                    map: mapfile,
                    colorscalerange: "0,0.4",
                });

                wmsLayer.setParams({
                    map: mapfile,
                    // COLORSCALERANGE: colorscalerange,
                    worldCopyJump: true,
                    continuousWorld: false,
                });

                if (wmsLayer && this.common.map) {
                    wmsLayer.addTo(this.common.map)
                }

            }
        }

    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    async setSimulationLayers(simulation: any, map: any, zoom: boolean = false, curr_oil0: boolean) {

        console.log("setSimulationLayers: ", simulation, curr_oil0)  
    
        if (this.common.simulationLayer) this.common.map.removeLayer(this.common.simulationLayer);
        if (this.common.simulationTimeLayer) this.common.map.removeLayer(this.common.simulationTimeLayer);
        if (this.common.timeDimensionControl) this.common.map.removeControl(this.common.timeDimensionControl);
        if (this.common.map.timeDimension) this.common.map.timeDimension = null;

        this.common.colorbarOilUrl = null
        this.common.colorbarEnvUrl = null

        let sim_id = parseInt(simulation.sim_id);
        let urlWMS = this.common.sim_results_url + "map=/var/www/html/cache/DSS/WITOIL/simulations/99999" + sim_id + "/99999" + sim_id + ".map";

        let timeDimension = new L.TimeDimension();
        this.common.map.timeDimension = timeDimension;

        if (this.common.player && this.common.player.isPlaying()) {
            this.common.player.stop();
        }

        this.common.player = new L.TimeDimension.Player({
            // transitionTime: 500,
            buffer: 25,
            // minBufferReady: 10,
            loop: true,
            startOver: true
        }, timeDimension);


        var timeDimensionControlOptions = {
            player: this.common.player,
            timeDimension: timeDimension,
            position: 'bottomleft',
            autoPlay: true,
            minSpeed: 1,
            speedStep: 1,
            maxSpeed: 5,
            timeSliderDragUpdate: true
        };
        this.common.timeDimensionControl = new L.Control.TimeDimension(timeDimensionControlOptions);
        this.common.map.addControl(this.common.timeDimensionControl);

        this.common.simulationLayer = L.tileLayer.wms(urlWMS, {
            layers: '',
            format: 'image/png',
            transparent: true,
            attribution: 'CMCC',
            visualization_options: {
                'curr_sim_res_totaloil': this.common.visualization_options.curr_sim_res_totaloil,
                'curr_sim_res_beached': this.common.visualization_options.curr_sim_res_beached,
                'curr_sim_res_env': this.common.visualization_options.curr_sim_res_env,
            }
        });
        let proxy = this.common.proxy_url + '?req=timedimension';
        console.log("proxy", proxy)
        this.common.simulationTimeLayer = L.timeDimension.layer.wms.CMCC(
            this.common.simulationLayer,
            {
                proxy: proxy,
                updateTimeDimension: true,
                updateTimeDimensionMode: "intersect",
                requestTimeFromCapabilities: true,
                getCapabilitiesUrl: urlWMS,
                // getCapabilitiesLayerName: 'IDXLAYER',
                _getCapabilitiesAlternateLayerName: 'IDXLAYER',
                wmsVersion: '1.3.0',
                setDefaultTime: true,		// nel mapfile -> "wms_timedefault" 
            }
        );

        this.common.simulationTimeLayer._getbbox(this.bboxCallback, this.common.map, zoom)
        if(curr_oil0) {
            this.common.simulationTimeLayer.addTo(this.common.map);
            this.common.simulationTimeLayer.bringToFront();
        }

        // Colorbar
        this.common.map.timeDimension.on('timeload', function (data) {
            if (data.target._currentTimeIndex === 0 && this.common.curr_simulation) {
                this.colorbarEnvUrl = null
                this.colorbarOilUrl = null
                this.setColorbar()
            }
        }, this)

    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    bboxCallback(bbox, map, zoom) {
        let bounds = new L.LatLngBounds(bbox);
        if (zoom) {
            map.fitBounds(bounds);
        } else {
        }
    }

    /* ********************************************************************************************
     * 
     *  
     * 
     * ********************************************************************************************/
    setColorbar() {
        let layers = this.common.simulationLayer.options.layers.split(",");
        layers.forEach(layer => {
            if (this.common.colorbarEnvUrl == null && (layer.includes("sst_") || layer.includes("vhm0_") || layer.includes("vtza_") || layer.includes("curr_") || layer.includes("wind_"))) {
                // sst, vhm0, vtza, curr, wind
                this.common.colorbarEnvUrl = this.common.simulationLayer._url + "&version=1.1.1&service=WMS&REQUEST=GetLegendGraphic&MODE=legend&sld_version=1.1.0&LAYER=" + layer + "&format=image/png&STYLE=default"
                this.common.colorbarEnvUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.common.colorbarEnvUrl)
            }

            if (this.common.colorbarOilUrl == null && (layer.includes("mdslk_totaloil_") || layer.includes("mdslk_ppppbeached_"))) {
                this.common.colorbarOilUrl = this.common.simulationLayer._url + "&version=1.1.1&service=WMS&REQUEST=GetLegendGraphic&MODE=legend&sld_version=1.1.0&LAYER=" + layer + "&format=image/png&STYLE=default"
                this.common.colorbarOilUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.common.colorbarOilUrl)
            }
        });
    }


}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts